import { FieldArray, useFormikContext } from "formik";
// @ts-expect-error pure js
import TextInput from "../UI/TextInput";
// @ts-expect-error pure js
import TextArea from "../UI/TextArea";
import Card from "../UI/Card";
// @ts-expect-error pure js
import { TextOneOrMany } from "../../utils";
// @ts-expect-error pure js
import RepresentedBy from "../UI/RepresentedBy";
// @ts-expect-error pure js
import TabbedForm from "../UI/TabbedForm";
import { ModalDialogBody } from "../UI/ModalDialog";
import Text from "../UI/Text";
import type { Profile } from "../Profile/types";
import styles from "./EdlFirstPageForm.module.css";

interface EdlFirstPageFormValues {
  profiles?: unknown[];
  profiles_bailleurs?: unknown[];
}

interface EdlFirstPageFormProps {
  tenantProfiles: Profile[];
  bailleurProfiles?: Profile[];
}

export default function EdlFirstPageForm({
  tenantProfiles,
  bailleurProfiles,
}: EdlFirstPageFormProps) {
  const { values } = useFormikContext<EdlFirstPageFormValues>();

  return (
    <>
      <ModalDialogBody>
        <div className={styles.container}>
          <div className={styles.fields}>
            <TextInput
              type="date"
              name="date"
              label="Date de l'état des lieux"
              marginForm=""
            />
            <TextArea
              name="description"
              label="Commentaire global"
              placeholder="Exemple : cet état des lieux est intermédiaire et est réalisé à l'occasion de l'entrée de M.X dans la colocation"
              rows="4"
              marginForm=""
            />
            <Card type="blue">
              <Text weight="bold">
                <TextOneOrMany
                  one="Bailleur présent"
                  many="Bailleurs présents"
                  number={bailleurProfiles?.length}
                />
              </Text>
              <FieldArray
                name="profiles_bailleurs"
                render={() =>
                  bailleurProfiles?.map((profile, index) => (
                    <RepresentedBy
                      key={profile.id}
                      profile={profile}
                      prefixName={`profiles_bailleurs[${index}]`}
                      check={values.profiles_bailleurs?.[index]}
                    />
                  ))
                }
              />
            </Card>
            <Card type="blue">
              <Text weight="bold">
                <TextOneOrMany
                  one="Locataire présent"
                  many="Locataires présents"
                  number={tenantProfiles.length}
                />
              </Text>
              <FieldArray
                name="profiles"
                render={() =>
                  tenantProfiles.map((profile, index) => (
                    <RepresentedBy
                      key={profile.id}
                      profile={profile}
                      prefixName={`profiles[${index}]`}
                      check={values.profiles?.[index]}
                    />
                  ))
                }
              />
            </Card>
          </div>
        </div>
      </ModalDialogBody>
      <TabbedForm.Actions sticky />
    </>
  );
}
